<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl" style="position: relative !important">
      <!-- Loading Overlay -->
      <div v-if="loading" class="loading-overlay d-flex justify-content-center mb-3">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div class="text-container">
        <div class="title-area">
            <h1 class="page-title">
                {{ screentexts[38]?screentexts[38].element_text:'Set Survey Information' }}:
                <span :class="`${anon ? 'g-anon-lg' : '' }`">
                  {{ group_name }}
                </span>
                <!-- <PopupBubble
                  v-if="screentexts[38] && screentexts[38].element_bubbletext !== '' && screentexts[38].element_bubbletext !== null"
                  element_id="set-information"
                  screenelement_id="38"
                  :screen_id="screen_id"
                  :bubbletext="screentexts[38]?screentexts[38].element_bubbletext:''"
                /> -->
            </h1>
        </div>
        <div class="pb-4">
          {{ screentexts[39]?screentexts[39].element_text:"Now it's time to set up your new survey. Please note that your “survey type” settings cannot be changed once your survey has been sent. Neither which optional questions to include or exclude in your survey. Remaining settings can be changed until you run your report." }}
        </div>
        <div class="pb-4">
          <span class="text-danger">*</span> Mandatory
        </div>
        <div class="mb-4" v-if="Number(survey_type_id) !== 3">
          <label class="form-label">{{ screentexts[40]?screentexts[40].element_text:'Give your survey a name.' }}</label>
          <input
            required
            :class="['form-control', anon ? 'g-anon' : '', survey_name_error ? 'is-invalid' : '']"
            v-model="survey_name"
            @input="survey_name_error = false"
            :placeholder="screentexts[41]?screentexts[41].element_text:'Survey name.'"
            type="text"
          />
          <div v-if="survey_name_error" class="invalid-feedback">Survey name is required.</div>
          <div v-else class="form-text px-0">{{ screentexts[40]?screentexts[40].element_bubbletext:'' }}</div>
        </div>

        <div class="mb-4">
          <label class="form-label">{{ screentexts[55]?screentexts[55].element_text:'Select survey type' }}</label>
          <select
            v-model="survey_type_id"
            :class="['form-control', anon ? 'g-anon' : '']"
            @change="survey_type_selected"
          >
            <option v-for="option in surveytype_options" :key="option.value" :value="option.value">
              {{ option.text }}
            </option>
          </select>
          <div class="form-text px-0">{{ screentexts[57]?screentexts[57].element_bubbletext:'' }}</div>
        </div>

        <div class="mb-4" v-if="survey_type_id !== 3">
          <label class="form-label">{{ screentexts[128]?screentexts[128].element_text:'Select language' }}</label>
          <select
            v-model="survey_language_id"
            :class="['form-control', anon ? 'g-anon' : '']"
            @change="language_selected"
          >
            <option v-for="option in language_options" :key="option.value" :value="option.value">
              {{ option.text }}
            </option>
          </select>
          <div class="form-text px-0">{{ screentexts[129]?screentexts[129].element_bubbletext:'' }}</div>
        </div>

        <div class="mb-4" v-if="survey_type_id !== 3">
          <label class="form-label">{{ screentexts[50]?screentexts[50].element_text:'Select country' }}</label>
          <select
            v-model="survey_normvalues_id"
            :class="['form-control', anon ? 'g-anon' : '']"
            @change="normvalue_selected"
          >
            <option v-for="option in norm_values_options" :key="option.value" :value="option.value">
              {{ option.text }}
            </option>
          </select>
          <div class="form-text px-0">{{ screentexts[51]?screentexts[51].element_bubbletext:'' }}</div>
        </div>

        <!-- Optional questions -->
        <div v-if="excludablequestions.length > 0 && Number(survey_type_id) === 1" class="mb-4">
          <div class="d-flex justify-content-between align-items-center pb-2">
            <h4>{{ screentexts[58]?screentexts[58].element_text:'Optional questions' }}</h4>
            <div
              ref="optionalTooltip"
              class="optional-tooltip-container"
              @click="toggleOptionalTooltip"
            >
              <span class="tooltip-question" style="color: #007bff;">
                <i class="fa-regular fa-circle-question"></i>
              </span>
              <div v-if="showOptionalTooltip" class="custom-inline-tooltip">
                <div class="alert alert-info p-2 mb-0" role="alert">
                  <p class="optional-tooltip-header m-0">
                    {{ screentexts[59]?screentexts[59].element_text:'Additional questions' }}
                  </p>
                  <p class="m-0">
                    {{ screentexts[60]?screentexts[60].element_text:'The questions below are not mandatory and can be excluded or included depending on the needs of a survey.' }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="excludablequestions.length > 0" class="d-grid gap-2">
            <div
              v-for="q in excludablequestions"
              :key="q.generalquestion_id"
              class="form-check mb-1"
            >
              <input
                :id="'additional_' + q.generalquestion_id"
                v-model="excludedquestions"
                :value="q.generalquestion_id"
                type="checkbox"
                class="form-check-input"
              />
              <label :for="'additional_' + q.generalquestion_id" class="form-check-label">
                {{ q.generalquestion_text }}
              </label>
            </div>
          </div>

          <p class="text-muted small mt-2 mb-4">
            {{ screentexts[61]?screentexts[61].element_text:'Uncheck questions that should not be part of your survey.' }}
          </p>
        </div>

        <!-- Extra questions -->
        <div v-if="addon_surveys.length > 0 && survey_type_id !== 3" class="mb-4">
          <label class="form-label">Extra questions</label>
          <div class="d-grid gap-2">
            <div
              v-for="addon in addon_surveys"
              :key="addon.id"
              class="form-check"
            >
              <input
                :id="'addon_' + addon.id"
                v-model="addon_checked"
                type="checkbox"
                class="form-check-input"
              />
              <label :for="'addon_' + addon.id" class="form-check-label">
                {{ addon.survey_name }}
              </label>
            </div>
          </div>
          <div class="form-text px-0">When checked, the extra questions are added to every member of this survey.</div>
        </div>

        <!-- Save error -->
        <div v-if="save_error" class="alert alert-danger mt-3" role="alert">
          {{ save_error }}
        </div>

        <!-- Button area -->
        <div class="d-flex justify-content-between mt-3 mb-5">
          <div>
            <button
              v-if="prev_button"
              type="button"
              @click="$router.push({ name: 'creategroupsurvey' })"
              class="btn btn-secondary"
            >
              {{ screentexts[26]?screentexts[26].element_text:'< Back' }}
            </button>
          </div>
          <div class="d-flex gap-2">
            <button
              type="button"
              @click="save_only"
              class="btn btn-secondary"
            >
              {{ screentexts[19]?screentexts[19].element_text:'Save' }}
            </button>
            <button
              type="button"
              @click="save_and_continue"
              class="btn btn-primary"
            >
              {{ screentexts[20]?screentexts[20].element_text:'Next >' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'

const store = useStore()
const router = useRouter()

// Reactive data
const profile = ref(store.state.profile)
const group_name = ref(store.state.currentgroup.group_name)
const suvey_id = ref(0)
const survey_name = ref(store.state.currentsurvey.survey_name)
const survey_language_id = ref(store.state.currentsurvey.survey_language_id)
const survey_normvalues_id = ref(store.state.currentsurvey.survey_normvalues_id)
const survey_type_id = ref(store.state.currentsurvey.survey_type_id)
const survey_invoice_reference = ref(store.state.currentsurvey.survey_invoice_reference)
const spotify = ref(store.state.currentsurvey.spotify)
const surveytype_options = ref([])
const excludablequestions = ref([])
const excludedquestions = ref([])
const has_online = ref(0)
const has_paper = ref(0)
const screen_id = ref(5)
const screentexts = ref([])
const language_options = ref([])
const survey_name_error = ref(false)
const norm_values_options = ref([])
const loading = ref(false)
const showOptionalTooltip = ref(false)
const survey = ref({})
const prev_button = ref(true)
const save_error = ref('')
const addon_surveys = ref([])
const addon_checked = ref(false)

// Computed properties
const anon = computed(() => store.state.anon)
const survey_id = computed({
  get() {
    return store.state.currentsurvey_id
  },
  set() {
    // NOOP - read-only for now
  }
})

// Watchers
watch(survey_id, () => {
  survey_name.value = store.state.currentsurvey.survey_name
  survey_language_id.value = store.state.currentsurvey.survey_language_id
  survey_normvalues_id.value = store.state.currentsurvey.survey_normvalues_id
  survey_type_id.value = store.state.currentsurvey.survey_type_id
  survey_invoice_reference.value = store.state.currentsurvey.survey_invoice_reference
  
  const members = store.state.currentsurveymembers
  has_online.value = 0
  has_paper.value = 0
  for (let i = 0; i < members.length; i++) {
    const formOption = Number(members[i].groupsurveymember_formoption_id)
    const included = members[i].included_in_survey === 1 || members[i].included_in_survey === true || members[i].included_in_survey === '1'
    if ((formOption === 1 || formOption === 3) && included) { has_online.value = 1 }
    if (formOption === 2 && included) { has_paper.value = 1 }
  }
  excludablequestions_get()
  addons_get()
})

watch(survey_language_id, () => {
  excludablequestions_get() // Refetch excludable questions when language changes
})

watch(survey_type_id, async () => {
  if (Number(survey_type_id.value) === 2) {
    survey_normvalues_id.value = 999
  }
  await normvalues_countries_get()
})

// Methods
const toggleOptionalTooltip = (event) => {
  event.stopPropagation()
  showOptionalTooltip.value = !showOptionalTooltip.value
}

const handleOutsideClick = (event) => {
  const wrapper = document.querySelector('.optional-tooltip-container')
  if (!wrapper) {
    return
  }
  if (!wrapper.contains(event.target)) {
    showOptionalTooltip.value = false
  }
}

const logit = () => {
  // NOOP
}

const spotify_invoice_reference_get = () => {
  if (profile.value.spotify === '1') {
    if (spotify.value === '1' && Number(survey_type_id.value) === 2) {
      store.dispatch('syspref_get', { name: 'spotify_invoice_reference' })
        .then((resp) => {
          survey_invoice_reference.value = resp.data.value
        })
    } else {
      survey_invoice_reference.value = ''
    }
  }
}

const parse_email = (email) => {
  // eslint-disable-next-line
  const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;   
  return pattern.test(email.toLowerCase())
}

const language_options_get = (survey_type_id) => {
  const filter = {}
  if (spotify.value === '1' && Number(survey_type_id) === 2) {
    language_options.value = []
    language_options.value.push({
      value: 38,
      text: 'English'
    })
    survey_language_id.value = 38
    return true
  }
  switch (survey_type_id) {
    case '1':
      filter.language_enabled = {
        operator: '=',
        value: '1'
      }
      break
    case '2':
      filter.language_enabled_gdq_short = {
        operator: '=',
        value: '1'
      }
      break
    case '3':
      filter.language_enabled_osc = {
        operator: '=',
        value: '1'
      }
      break
    default:
      filter.language_enabled = {
        operator: '=',
        value: '1'
      }
  }
  store.dispatch('records_readall', { table_name: 'g_languages', filter, orderby: 'language_name' })
    .then((resp) => {
      language_options.value = []
      for (let i = 0; i < resp.data.result.length; i++) {
        language_options.value.push({
          value: resp.data.result[i].id,
          text: resp.data.result[i].language_name
        })
        if (resp.data.result[i].id === 38) {
          survey_language_id.value = resp.data.result[i].id
        }
      }
      if (survey.value.survey_language_id !== 0) {
        survey_language_id.value = survey.value.survey_language_id
        return true
      }
      if (store.state.currentsurvey.survey_language_id !== 0) {
        survey_language_id.value = store.state.currentsurvey.survey_language_id
        return true
      }
      if (store.state.currentgroup) {
        survey_language_id.value = store.state.currentgroup.group_language_id
        return true
      }
    })
  return true
}

const profile_get = async () => {
  await store.dispatch('profile_fetch')
    .then((resp) => {
      profile.value = resp.data
      store.dispatch('surveytypes_fetch')
        .then((resp) => {
          const items = resp.data.result
          const options = []
          for (let i = 0; i < items.length; i++) {
            const option = {
              value: items[i].id,
              text: items[i].surveytype_name
            }
            options.push(option)
          }
          surveytype_options.value = options
        })
    })
  if (profile.value.spotify === '1') { spotify.value = '1' }
}

const screentexts_get = async () => {
  const screentexts_array = []
  const filter = {
    screen_id: {
      operator: '=',
      value: screen_id.value
    }
  }
  await store.dispatch('systemscreenelements_fetch', { filter })
    .then((resp) => {
      const dbtexts = resp.data.result
      for (let i = 0; i < dbtexts.length; i++) {
        const screentext = {
          id: dbtexts[i].id,
          element_text: dbtexts[i].element_text,
          element_bubbletext: dbtexts[i].element_bubbletext
        }
        screentexts_array[dbtexts[i].id] = screentext
      }
      screentexts.value = screentexts_array
    })
}

const groupsurvey_save = async () => {
  const excludedquestions_filtered = excludablequestions.value.filter(
    q => !excludedquestions.value.includes(q.generalquestion_id)
  ).map(q => q.generalquestion_id)
  
  await store.dispatch('excludedquestions_save', { survey_id: survey_id.value, questions: excludedquestions_filtered })

  const survey_data = {
    id: store.state.currentsurvey_id,
    survey_name: survey_name.value,
    survey_language_id: survey_language_id.value,
    survey_normvalues_id: survey_normvalues_id.value,
    survey_type_id: survey_type_id.value,
    survey_invoice_reference: survey_invoice_reference.value,
    survey_start_date: store.state.currentsurvey.survey_start_date,
    survey_end_date: store.state.currentsurvey.survey_end_date,
    survey_reminder_date: store.state.currentsurvey.survey_reminder_date,
    survey_reminder_email: store.state.currentsurvey.survey_reminder_email,
    survey_reminder_mobile: store.state.currentsurvey.survey_reminder_mobile,
    survey_reminder: store.state.currentsurvey.survey_reminder,
    spotify: profile.value.spotify === '1' && survey_type_id.value === '2' && spotify.value === '1' ? '1' : '0',
    addon_survey: addon_checked.value && addon_surveys.value.length > 0 ? addon_surveys.value[0].id : 0
  }
  
  await store.dispatch('groupsurvey_save', { survey: survey_data })
    .then(async (resp) => {
      const surveyId = resp.data.id
      const data = {
        survey_id: surveyId,
        survey_language_id: survey_data.survey_language_id,
        survey_type_id: survey_data.survey_type_id
      }
      
      await store.dispatch('groupsurvey_changelanguage', data)
        .then(async (resp) => {
          // Not using the results for this operation, but keeping it for completeness
          survey_get()
          await store.dispatch('groupsurvey_setcurrent', { survey_id: surveyId })
           return true
        })
    })
}

const group_get = async () => {
  await store.dispatch('group_fetch')
    .then(() => {
      store.dispatch('groupmembers_fetch', { group_id: store.state.currentgroup_id })
    })
}

const survey_get = async () => {
  has_online.value = 0
  has_paper.value = 0
  
  await store.dispatch('groupsurvey_fetch', { id: store.state.currentsurvey_id })
    .then((resp) => {
      survey.value = resp.data
      survey_name.value = resp.data.survey_name || ''
      survey_language_id.value = resp.data.survey_language_id
      survey_normvalues_id.value = resp.data.survey_normvalues_id
      survey_type_id.value = resp.data.survey_type_id
      store.dispatch('groupsurveymembers_fetch', { survey_id: resp.data.id })
        .then((resp2) => {
          const members = resp2.data.result
          for (let i = 0; i < members.length; i++) {
            const formOption = Number(members[i].groupsurveymember_formoption_id)
            const included = members[i].included_in_survey === 1 || members[i].included_in_survey === true || members[i].included_in_survey === '1'
            if ((formOption === 1 || formOption === 3) && included) { has_online.value = 1 }
            if (formOption === 2 && included) { has_paper.value = 1 }
          }
        })
    })
    .then(() => {
      store.commit('survey_set', survey.value)
    })
}

const addons_get = async () => {
  addon_surveys.value = []
  addon_checked.value = false
  const eid = Number(profile.value.enterprise_id || 0)
  if (eid <= 0) return
  await store.dispatch('records_readall', {
    table_name: 'g_addon_surveys',
    filter: {
      enterprise_id: {
        operator: '=',
        value: String(eid)
      }
    },
    orderby: 'survey_name'
  })
    .then((resp) => {
      addon_surveys.value = resp.data.result
      addon_checked.value = addon_surveys.value.length > 0
        && Number(store.state.currentsurvey.addon_survey) === Number(addon_surveys.value[0].id)
    })
}

const excludablequestions_get = async () => {
  loading.value = true
  excludablequestions.value = []
  excludedquestions.value = []
  
  await store.dispatch('excludedquestions_fetch', { survey_id: survey_id.value })
    .then((resp) => {
      excludablequestions.value = resp.data.questions
      for (let i = 0; i < resp.data.questions.length; i++) {
        excludablequestions.value[i].generalquestion_text = excludablequestions.value[i].generalquestion_text.replace(/:/g, '')
        excludablequestions.value[i].value = excludablequestions.value[i].generalquestion_id
        excludablequestions.value[i].text = excludablequestions.value[i].generalquestion_text
        excludablequestions.value[i].exluded = 1
        
        if (resp.data.questions[i].excluded === 0) {
          if (!excludedquestions.value.includes(resp.data.questions[i].generalquestion_id)) {
            excludedquestions.value.push(resp.data.questions[i].generalquestion_id)
          }
        } else {
          const index = excludedquestions.value.indexOf(resp.data.questions[i].generalquestion_id)
          if (index !== -1) {
            excludedquestions.value.splice(index, 1)
          }
        }
      }
      // If nothing is marked yet, default to checking all additional questions
      if (excludedquestions.value.length === 0 && excludablequestions.value.length > 0) {
        excludedquestions.value = excludablequestions.value.map(q => q.generalquestion_id)
      }
    })
  loading.value = false
}

const normvalues_countries_get = async () => {
  norm_values_options.value = []
  // Always include Global for GDQ Short (type 2); include for Spotify, too.
  if (Number(survey_type_id.value) === 2) {
    norm_values_options.value.push({
      value: 999,
      text: 'Global'
    })
    survey_normvalues_id.value = 999
  }

  const options = []
  await store.dispatch('normvalues_countries_fetch')
    .then((resp) => {
      const countries = resp.data
      for (let i = 0; i < countries.length; i++) {
        if (countries[i].country_id === 999 || Number(survey_type_id.value) === 1) {
          const option = {
            value: countries[i].country_id,
            text: countries[i].country_name
          }
          options.push(option)
        }
      }
      norm_values_options.value = [...norm_values_options.value, ...options]
      
      if (survey.value.survey_language_id !== 0) {
        survey_language_id.value = survey.value.survey_language_id
        return true
      }
      if (store.state.currentsurvey.survey_normvalues_id !== 0) {
        survey_normvalues_id.value = store.state.currentsurvey.survey_normvalues_id
        return true
      }
      if (store.state.currentgroup) {
        survey_normvalues_id.value = store.state.currentgroup.survey_normvalues_id
        return true
      }
    })
}

// Lifecycle hooks
onMounted(async () => {
  loading.value = true
  await profile_get()
  await screentexts_get()
  await group_get()
  await survey_get()
  await excludablequestions_get()
  await addons_get()
  await normvalues_countries_get()
  await language_options_get(survey_type_id.value)
  await spotify_invoice_reference_get()
  loading.value = false
  
  // Add event listener for outside clicks
  document.addEventListener('click', handleOutsideClick)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', handleOutsideClick)
})

// Additional helper functions for the UI workflow
const survey_type_selected = () => {
  // This can be extended if needed but mainly for UI interaction and triggers watchers
}

const language_selected = () => {
  // UI interaction handler
}

const normvalue_selected = () => {
  // UI interaction handler
}

const validate = () => {
  survey_name_error.value = Number(survey_type_id.value) !== 3 && !survey_name.value.trim()
  return !survey_name_error.value
}

const save_only = async () => {
  if (!validate()) return
  save_error.value = ''
  try {
    await groupsurvey_save()
  } catch (e) {
    save_error.value = e?.response?.data?.message || e?.message || 'Failed to save. Please try again.'
  }
}

const save_and_continue = async () => {
  if (!validate()) return
  save_error.value = ''
  try {
    await groupsurvey_save()
  } catch (e) {
    save_error.value = e?.response?.data?.message || e?.message || 'Failed to save. Please try again.'
    return
  }
  router.push({ name: 'creategroupsurveyemailsettings' })
}
</script>

<style scoped>
.gdq-strike {
  text-decoration: line-through;
}
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8); /* Semi-transparent background */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.optional-tooltip-header {
  margin-bottom: 0.35rem;
}

.optional-tooltip-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0;
  padding-left: 0;
}

.optional-tooltip-container p {
  display: inline-flex;
  align-items: center;
  margin: 0;
  margin-right: 0;
  padding-right: 0;
  white-space: nowrap;
}

.optional-tooltip-container .tooltip-question {
  margin-left: 2px;
  padding-left: 0;
}

.custom-inline-tooltip {
  position: absolute;
  top: 50%;
  left: calc(100% + 6px);
  transform: translateY(-50%);
  min-width: 200px;
  z-index: 20;
}

.optional-tooltip-container .custom-inline-tooltip {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
  width: auto;
  color: inherit;
  line-height: 1.4;
}

.optional-tooltip-container .custom-inline-tooltip::before,
.optional-tooltip-container .custom-inline-tooltip::after {
  display: none;
}
</style>